// src/pages/FreeHomeDelivery.js
import React from 'react';
import { Container } from 'react-bootstrap';
import FreeHomeDelivery from '../components/FreeHomeDelivery';
const FreeHomeDeliveryPage = () => {
  return (
   <Container className="my-5">
     <FreeHomeDelivery/>
   </Container>
  );
};

export default FreeHomeDeliveryPage;
